import { styled, TableCell, TableRow } from '@mui/material';
import { OrtPeriod } from '@types';
import { DayHeaderCell } from './ort-table-day-header-cell';

const StyledTableCell = styled(TableCell)({
  fontWeight: 'bold',
  width: '20%',
});

type OrtTableRowProps = {
  label: string;
  ranges: OrtPeriod[];
};

export const OrtTableRow = ({ label, ranges }: OrtTableRowProps) => {
  if (!ranges.length) {
    return (
      <TableRow>
        <DayHeaderCell label={label} rowSpan={1} />
        <StyledTableCell>--:--</StyledTableCell>
        <StyledTableCell>--:--</StyledTableCell>
        <StyledTableCell>-</StyledTableCell>
      </TableRow>
    );
  }

  return (
    <>
      {ranges.map((range, idx) => (
        <TableRow key={`${label}-${idx}`}>
          {idx === 0 && <DayHeaderCell label={label} rowSpan={ranges.length} />}
          <StyledTableCell>{range.startTime.slice(0, 5)}</StyledTableCell>
          <StyledTableCell>{range.endTime.slice(0, 5)}</StyledTableCell>
          <StyledTableCell>
            {range.surchargeType === 'factor' ? `${range.surcharge}%` : `€${range.surcharge}`}
          </StyledTableCell>
        </TableRow>
      ))}
    </>
  );
};
